<template>
  <div>
    <b-table
      class="table-collaborators"
      responsive
      no-border-collapse
      :items="items"
      :fields="fields"
    >
      <template #cell(date)="row">
        <template v-if="row.item.dates">
            <span
              v-for="({ month, dates }, index) in row.item.dates"
              :key="index"
              class="text-bold"
            >
              <span v-for="(day, days_index) in dates" :key="days_index">
                {{ day | moment("DD")}}{{ dates.length - 1 > days_index ? "," : null }}
              </span>
              de {{ month }}
            </span>
        </template>
        <template v-if="row.item.days">
          <span>{{ row.item.days }}</span>
        </template>
      </template>
      <template #cell(city)="row">
        <span v-if="row.item?.ticket?.destination">{{ row.item?.ticket?.destination }}</span
        >,
        <span>{{
          row.item?.ticket?.type == "internacional" ? "Internacional" : `${textTransform(row.item?.ticket?.origin_department?.toLowerCase())},Colombia`
        }}</span>
      </template>
      <template #cell(city_initial)="row">
        <span>{{ row.item?.ticket?.city }}</span
        >,
        <span>{{
          row.item?.ticket?.type == "internacional" ? "Internacional" : `${textTransform(row.item?.ticket?.origin_department?.toLowerCase())},Colombia`
        }}</span>
      </template>
      <template #cell(city_final)="row">
        <span>{{ row.item?.ticket?.destination }}</span>
        <!-- <span>{{
          row.item?.ticket?.destination_department == "internacional"
            ? "Internacional"
            : `${textTransform(row.item?.ticket?.destination_department?.toLowerCase())},Colombia`
        }}</span> -->
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    textTransform(text) {
      return text ? text?.charAt(0).toUpperCase() + text?.slice(1) : '';
    }
  }
};
</script>

<style lang="css">
.table-collaborators table thead {
  background-color: #eceff1 !important;
  color: #546e7a !important;
  border: none !important;
  font-family: Ubuntu !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 1.25rem !important;
}

.table-collaborators table thead th {
  border-bottom: none !important;
  padding: 15px 10px !important;
  font-size: 14px !important;
}

.table-collaborators table tbody tr {
  font-family: Ubuntu !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 1.25rem !important;
  border-bottom: 1px solid #CFD8DC !important;
  text-align: left !important;
}

.table-collaborators table tbody tr td {
  border-bottom: none !important;
}

.table-collaborators table tbody tr td:nth-child(4) {
  width: 200px !important;
}
</style>
